import { assign, retrieve } from './util';
import defaultConfig from './defaultConfig';

export var version = '5.4.1';

export function setRuntimeConfig() {
    if (typeof window.uwr === 'object' && typeof window.uwr.config === 'object') {
        assign('uwr_.runtime.config', window.uwr.config);
    }
}

export function setDefaultConfig() {
    Object.keys(defaultConfig).forEach(function (key) {
        config(key, defaultConfig[key]);
    });
}

/**
 * Gets or sets a runtime config parameter.
 * @param {string} name of the config parameter
 * @param {object} value of the config parameter
 * @return If only the first parameter is passed then returns the value associated to the key if exists otherwise
 *         undefined.
 */
export function config() {
    if (arguments.length === 1) {
        return retrieve('uwr_.runtime.config.' + arguments[0]);
    } else if (arguments.length === 2) {
        assign('uwr_.runtime.config.' + arguments[0], arguments[1]);
    }
}



//////////////////
// WEBPACK FOOTER
// ./loader/core.js
// module id = 10
// module chunks = main